import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import RowClick from '../../../common/RowClick';
import { cellNegtiveRed } from '../../../common/table/CustomCellTable';
import Table from '../../../common/table/Table';
import TextBlink from '../../../common/table/TextBlink';
import CellHover from '../../../market/watchlist/summary/CellHover';
import {
  capitalizeFirstLetter,
  getDataFollowKeyByDot,
} from '../../../helpers/Common';
import {
  formatPercent,
  formatTextFloat,
  formatValueBillion,
  formatVolume,
  formatPrice,
  formatValue,
} from '../../../helpers/Text';
import { getSortStateParams } from '../helper';
import {
  REDUCER_NAME,
  loadMoreData,
  changeSortState,
  getScreenerData,
} from '../reducer';
import TradingViewUrl from '../../../common/TradingViewUrl';
import Const from './Const';

class TableResult extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 30,
    };
    this.tableRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.page === 1) {
      this.resetScroll();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState, getScreenerData } = this.props;
    if (sortState !== prevProps.sortState) {
      getScreenerData(getSortStateParams(sortState));
    }
  }

  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectScreenerDataByTicker;

  handleScroll = e => {
    const { totalPage, loadMoreData, page, isLoading } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;

    if (page === totalPage || isLoading) return;

    if (bottom) {
      const newpage = page + 1;
      loadMoreData(newpage);
    }
  };

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  getSector(icbCode) {
    const { listSector } = this.props;
    return (
      listSector.filter(item => item.icbCode === icbCode).pop().icbName || '--'
    );
  }

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          isString: true,
          render: (text, item) => {
            return (
              <CellHover
                organCode={item.stockScreenerItem.organCode}
                isShowDeleteIcon={false}
              >
                <TextBlink item={item} tradingDate="tradingDate">
                  <TradingViewUrl code={item.stockScreenerItem.organCode} />
                  &nbsp;{text}
                </TextBlink>
              </CellHover>
            );
          },
        };
      }

      if (_.includes([listColumn.SECTOR], key)) {
        return {
          ...result,
          isString: true,
          thStyle: { textAlign: 'left' },
          valueFromItem: item =>
            this.getSector(getDataFollowKeyByDot(item, listColumn.SECTOR)),
          render: (text, item) => {
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className="text-left"
              >
                {this.getSector(text)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RTD21], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {cellNegtiveRed(text)}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [listColumn.RTD11, listColumn.ISA20TTM, listColumn.ISA20Y],
          key,
        )
      ) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatValueBillion(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.RTD36,
            listColumn.RTQ29,
            listColumn.RTD36AVG,
            listColumn.RTQ12,
            listColumn.RTQ14,
            listColumn.RTD52,
            listColumn.RTD55,
            listColumn.RTQ160,
            listColumn.FREE_FLOAT_RATE,
            listColumn.ROE,
            listColumn.ROA,
            listColumn.RTQ166,
            listColumn.RTQ176,
            listColumn.ORGANIZATION_OWNERSHIP,
            listColumn.PERCENTPRICECHANGE1DAY,
            listColumn.PERCENTPRICECHANGE1WEEK,
            listColumn.PERCENTPRICECHANGE1MONTH,
            listColumn.PERCENTPRICECHANGE3MONTH,
            listColumn.PERCENTPRICECHANGE6MONTH,
            listColumn.PERCENTPRICECHANGE52WEEK,
            listColumn.PERCENTPRICECHANGEYTD,
            listColumn.PERCENTPRICECHANGEYTD,
            listColumn.RTD51,
            listColumn.RYD52,
            listColumn.RYQ160,
            listColumn.RYQ166,
            listColumn.RYQ176,
            listColumn.RTQ78,
            listColumn.RTQ83,
            listColumn.RTD20,
            listColumn.RTD20AVG,
            listColumn.RYQ25,
            listColumn.RTQ25,
            listColumn.RYQ29,
            listColumn.RTQ27,
            listColumn.RQQ27,
            listColumn.RQQ25,
            listColumn.RQQ29,
            listColumn.ForeignerPercentage,
            listColumn.RTQ79,
            listColumn.RQQ23,
            listColumn.CorpOwnership,
          ],
          key,
        )
      ) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {text !== '--' ? `${formatPercent(text)} % ` : '--'}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.AVERAGE_VOLUME_3MONTH], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.AVERAGE_VALUE_1MONTH,
            listColumn.TOTALMATCHVALUE,
            listColumn.AVERAGEVALUE1WEEK,
            listColumn.AVERAGEVALUE2WEEK,
            listColumn.AVERAGEVALUE1MONTH,
            listColumn.AVERAGEVALUE3MONTH,
          ],
          key,
        )
      ) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatValue(text))}
              </TextBlink>
            );
          },
        };
      }

      if (
        _.includes(
          [
            listColumn.CLOSE_PRICE,
            listColumn.MA20,
            listColumn.MA50,
            listColumn.MA100,
            listColumn.MA9,
            listColumn.MA75,
            listColumn.TOTALMATCHVOLUME,
            listColumn.AVERAGEVOLUME1WEEK,
            listColumn.AVERAGEVOLUME2WEEK,
            listColumn.AVERAGEVOLUME1MONTH,
            listColumn.AVERAGEVOLUME3MONTH,
            listColumn.ForeignerRoom,
          ],
          key,
        )
      ) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.RTD43], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(text, 0)}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.ICBRANK], key)) {
        return {
          ...result,
          render: (text, item) => {
            const total = getDataFollowKeyByDot(item, listColumn.ICBRANK_TOTAL);
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {text}/{total}
              </TextBlink>
            );
          },
        };
      }

      if (_.includes([listColumn.OVER_SMA50], key)) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          render: text => {
            if (text === false)
              return (
                <div className="text-center">
                  <span className="text-center text-s-color-3">
                    <i className="icon-remove-symbol" />
                  </span>
                </div>
              );
            else {
              return '';
            }
          },
        };
      }

      if (_.includes([listColumn.RTD14], key)) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {cellNegtiveRed(formatTextFloat(text, 0))}
            </TextBlink>
          ),
        };
      }

      if (
        _.includes(
          [listColumn.REVY, listColumn.REVTTM, listColumn.REVENUE_GROWTH],
          key,
        )
      ) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatValueBillion(text))}
            </TextBlink>
          ),
        };
      }

      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text)}
          </TextBlink>
        ),
      };
    });

  render() {
    const {
      isLoading,
      ids,
      listHideColumn,
      changeSortState,
      sortState,
    } = this.props;
    return (
      <RowClick>
        {onRowClick => (
          <Table
            clickRow={onRowClick}
            thValign="top"
            onSort={changeSortState}
            sortState={sortState}
            scrollRef={this.tableRef}
            isLoading={isLoading}
            ids={ids}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={listHideColumn || Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            schema={this.schema(Const.listColumn, 'stockScreener.resultHeader')}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    ids: state[REDUCER_NAME].listScreenerDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    page: state[REDUCER_NAME].page,
    listSector: state[REDUCER_NAME].listSector,
    listHideColumn: state[REDUCER_NAME].listHideColumn,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  loadMoreData,
  changeSortState,
  getScreenerData,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TableResult);
